import PropTypes from "prop-types";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";

import { window } from "@swa-ui/browser";
import { CustomerTheme } from "@swa-ui/design-tokens";

const DOCUMENT_ROOT = "root";
const PORTAL_ROOT = "portal-root";

/**
 * CreatePortal provides a consistent way to add content to React's portal feature of ReactDOM.
 */

export const PortalRoot = (props) => {
  const { children, className } = props;
  const [portalTarget, setPortalTarget] = useState(getPortalRoot());
  const documentRoot = window.document.getElementById(DOCUMENT_ROOT) ?? window.document.body;

  useEffect(() => {
    if (portalTarget) {
      portalTarget.className = "";
      className && portalTarget.classList.add(...className.split(" "));
    }
  }, [className]);

  useLayoutEffect(() => {
    if (!portalTarget) {
      const existingPortalTarget = getPortalRoot();

      if (!existingPortalTarget) {
        const newPortalTarget = window.document.createElement("div");

        newPortalTarget.setAttribute("id", PORTAL_ROOT);
        className && newPortalTarget.classList.add(...className.split(" "));
        documentRoot.insertBefore(newPortalTarget, documentRoot.firstChild);
      }

      setPortalTarget(getPortalRoot());
    }
  });

  return getPortalRoot() && createPortal(<CustomerTheme>{children}</CustomerTheme>, portalTarget);

  function getPortalRoot() {
    return window.document.getElementById(PORTAL_ROOT);
  }
};

PortalRoot.displayName = "PortalRoot";

PortalRoot.propTypes = {
  /** Content that will be rendered in the React Portal. */
  children: PropTypes.node,

  /** Additional classes for positioning the component. */
  className: PropTypes.string,
};
